let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kkDPU")).then(() => parcelRequire('kL0fx'));